import { useQuery } from '@tanstack/react-query';
import accountsService from '@/lib/api/accounts';

export function useAccountsMetrics(
  organizationId: string | undefined,
  filters?: { date_from?: string; date_to?: string },
) {
  return useQuery({
    queryKey: ['accounts-metrics', organizationId, filters?.date_from, filters?.date_to],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');

      const response = await accountsService.getAccountsMetrics(organizationId, filters);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch accounts metrics');
      }
      return response.data;
    },
    enabled: !!organizationId,
    staleTime: 30 * 1000,
  });
}
